import classnames from 'classnames';
import React, { useState } from 'react';

const CSS = require('./Textarea.module.scss');

interface TextareaProps {
  value?: string;
  onChange?: (e: any) => void;
  error?: boolean;
  className?: string;
  initialRows?: number;
  [key: string]: any;
}

function Textarea({
  value,
  onChange,
  className,
  error,
  initialRows = 7,
  ...rest
}: TextareaProps) {
  const [rows, setRows] = useState(initialRows);

  const classes = classnames(CSS.TextArea, {
    [CSS.Error]: error,
    [className]: !!className,
  });

  const onChangeCallback = (e) => {
    onChange && onChange(e);
    if (e.currentTarget.scrollHeight > e.currentTarget.offsetHeight) {
      setRows((rows) => rows + 1);
    }
  };

  return (
    <textarea
      className={classes}
      onChange={onChangeCallback}
      value={value}
      rows={rows}
      {...rest}
    />
  );
}

export default Textarea;
